import React from "react";
import "./details.scss";
import PlaceholderChart from "./../../assets/chartPlaceholderL6.svg";


const DetailsGoogle = () => {
 
  return (
    <div className="pageDetails pageDetailsDefault">
      <header class="appHeader">
        <div class="headerContent">
          <h2>
            <span class="featured">10N</span> ELECCIONES GENERALES 2019
          </h2>
        </div>
      </header>
      <div className="mainWrapper">
        <div className="colContainer">
          <div className="floatingBlock left">
            <div className="inner">
              <div className="mapSelectorContainer">
                <div className="buttonsContainer">
                  <button type="button" class="button current">
                    Congreso
                  </button>
                  <button type="button" class="button undefined">
                    Senado
                  </button>
                </div>
              </div>
              <div className="graphContainer">
                <div className="selectsContainer">
                  <div role="presentation" class="select">
                    <div class="selectLabel">
                      <span class="selectLabelTxt">Seleccione comunidad</span>
                    </div>
                    <ul class="selectItems"></ul>
                  </div>
                  <div role="presentation" class="select">
                    <div class="selectLabel">
                      <span class="selectLabelTxt">Seleccione provincia</span>
                    </div>
                    <ul class="selectItems"></ul>
                  </div>
                </div>
                <table className="infoTable">
                  <tbody>
                    <tr>
                      <td className="key">Votos contabilizados: </td>
                      <td className="value votes">1.000</td>
                      <td className="value votes_percent">100%</td>
                    </tr>
                    <tr>
                      <td className="key">Abstenciones: </td>
                      <td className="value votes">1.000</td>
                      <td className="value abstention_percent">100%</td>
                    </tr>
                    <tr>
                      <td className="key">Votos en blanco: </td>
                      <td className="value whites">1.000</td>
                      <td className="value whites_percent">100%</td>
                    </tr>
                    <tr>
                      <td className="key">Votos nulos: </td>
                      <td className="value null">1.000</td>
                      <td className="value null_percent">100%</td>
                    </tr>
                  </tbody>
                </table>
                <img
                  src={PlaceholderChart}
                  class="recharts-surface"
                  alt="Gráfico de barras"
                />
              </div>
            </div>
          </div>
          <div className="floatingBlock right">
            <div className="inner">
              <div class="cardBlock graphContainer">
                <div class="cardBlockHeader">
                  <h2 class="cardBlockTitle">
                    ESCRUTADO:<span class="cardBlockTitleSecondary">0%</span>
                  </h2>
                  <span class="cardBlockSubtitle cardBlockSubtitle__indicator">
                    Actualizado a las: "00:00"
                  </span>
                </div>
                <div class="cardBlockContent">
                  <div class="tabsContainer">
                    <section class="titles">
                      <div class="title current">Datos</div>
                      <div class="title">28A</div>
                    </section>
                    <div class="content">
                      <div class="table-datosContainer">
                        <div class="table-datosScroll">
                          <div class="table-wrapper">
                            <table summary="Escaños por partido.">
                              <thead>
                                <tr>
                                  <th class="partido">Partido</th>
                                  <th class="escanos">Escaños</th>
                                  <th class="porcentaje">%</th>
                                  <th class="votos">Votos</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td class="dato-nombre-partido">
                                    <span>
                                      <span class="partido">Partido 1</span>
                                    </span>
                                  </td>
                                  <td class="dato-escanos">123</td>
                                  <td class="dato-escanos">10</td>
                                  <td class="dato-escanos_votes">1.000.000</td>
                                </tr>
                                <tr>
                                  <td class="dato-nombre-partido">
                                    <span>
                                      <span class="partido">Partido 2</span>
                                    </span>
                                  </td>
                                  <td class="dato-escanos">123</td>
                                  <td class="dato-escanos">10</td>
                                  <td class="dato-escanos_votes">1.000.000</td>
                                </tr>
                                <tr>
                                  <td class="dato-nombre-partido">
                                    <span>
                                      <span class="partido">Partido 3</span>
                                    </span>
                                  </td>
                                  <td class="dato-escanos">123</td>
                                  <td class="dato-escanos">10</td>
                                  <td class="dato-escanos_votes">1.000.000</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                        <p class="table-datosLegend">
                          *UNIDAS PODEMOS: Podemos - IU - Equo - En Comú PODEM -
                          En Común Podemos
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="mainWrapper">
        <p className="buttonBackContainer">
          <button type="button" class="button current">
            Volver
          </button>
        </p>
      </div>
    </div>
  );
};

export default DetailsGoogle;
